(() => {
  'use strict';
  if (window.nuuniWishlistReady) return;
  window.nuuniWishlistReady = true;
  const key = 'nuuni:wishlist:v1';
  const selector = '[data-nu-wish]';
  let timer;
  function read() {
    const value = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(value) ? [...new Set(value.map(String).filter(id => /^\d+$/.test(id)))] : [];
  }
  function notify(message, error = false, source = null, removed = false) {
    let box = document.querySelector('.nu-wish-notice');
    const schedule = () => {
      clearTimeout(timer);
      if (!box.matches(':hover') && !box.contains(document.activeElement)) timer = setTimeout(() => { box.hidden = true; }, 8000);
    };
    if (!box) {
      box = document.createElement('div');
      box.className = 'nu-wish-notice';
      box.innerHTML = '<img class="nu-wish-notice__photo" alt="" width="44" height="52" hidden><span class="nu-wish-notice__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg></span><div class="nu-wish-notice__text" role="status" aria-live="polite" aria-atomic="true"><strong></strong><p></p></div><a class="nu-wish-notice__action" href="/search?view=ulubione">Zobacz</a><button class="nu-wish-notice__undo nu-wish-notice__action" type="button" hidden>Cofnij</button><button class="nu-wish-notice__close" type="button" aria-label="Zamknij komunikat">×</button>';
      box.querySelector('.nu-wish-notice__close').addEventListener('click', () => { clearTimeout(timer); box.hidden = true; });
      box.addEventListener('mouseenter', () => clearTimeout(timer));
      box.addEventListener('mouseleave', schedule);
      box.addEventListener('focusin', () => clearTimeout(timer));
      box.addEventListener('focusout', () => requestAnimationFrame(schedule));
      document.body.append(box);
    }
    box.hidden = false;
    box.dataset.state = error ? 'error' : removed ? 'removed' : 'added';
    box.querySelector('strong').textContent = error ? message : removed ? 'Usunięto z ulubionych' : 'Dodano do ulubionych';
    box.querySelector('p').textContent = error ? '' : (source?.dataset.nuWishName || '').split(',')[0];
    const original = source?.closest('article')?.querySelector('img');
    const photo = box.querySelector('.nu-wish-notice__photo');
    const imageUrl = original?.currentSrc || original?.getAttribute('src');
    photo.hidden = error || !imageUrl;
    box.querySelector('.nu-wish-notice__icon').hidden = !photo.hidden;
    if (imageUrl) photo.src = imageUrl;
    else photo.removeAttribute('src');
    const link = box.querySelector('a');
    link.hidden = error || removed;
    link.setAttribute('aria-label', 'Zobacz ulubione');
    const undo = box.querySelector('.nu-wish-notice__undo');
    undo.hidden = error || !removed;
    undo.setAttribute('aria-label', 'Cofnij usunięcie');
    undo.onclick = () => {
      try {
        const ids = read();
        if (source && !ids.includes(source.dataset.nuWish)) localStorage.setItem(key, JSON.stringify([...ids, source.dataset.nuWish]));
        render();
        notify('Przywrócono do ulubionych', false, source);
        link.focus({ preventScroll: true });
      } catch (_) { notify('Nie udało się przywrócić produktu.', true); }
    };
    schedule();
  }
  function render() {
    let ids;
    try { ids = read(); }
    catch (_) {
      document.querySelector('[data-nu-wish-storage-error]')?.removeAttribute('hidden');
      return;
    }
    document.querySelectorAll(selector).forEach(button => {
      const active = ids.includes(button.dataset.nuWish);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Usuń z ulubionych: ' : 'Dodaj do ulubionych: ') + button.dataset.nuWishName);
    });
    document.querySelectorAll('[data-nu-wish-count]').forEach(el => {
      el.textContent = ids.length;
      el.hidden = !ids.length;
    });
    document.querySelectorAll('[data-nu-wish-link]').forEach(el => el.setAttribute('aria-label', `Ulubione (${ids.length})`));
    const page = document.querySelector('[data-nu-wishlist]');
    if (page) {
      let shown = 0;
      page.querySelectorAll('[data-nu-wish-item]').forEach(card => {
        card.hidden = !ids.includes(card.dataset.nuWishItem);
        if (!card.hidden) shown++;
      });
      page.querySelector('[data-nu-wish-empty]').hidden = shown > 0;
      page.querySelector('[data-nu-wish-total]').textContent = shown;
      let recommendations = 0;
      document.querySelectorAll('[data-nu-wish-recommendation]').forEach(card => {
        const eligible = !ids.includes(card.dataset.nuWishRecommendation);
        card.hidden = !eligible;
        if (!card.hidden) recommendations++;
      });
      const cross = document.querySelector('[data-nu-wish-cross]');
      if (cross) cross.hidden = recommendations === 0;
    }
  }
  // Capture replaces the isolated visual-only handlers still used by older sections.
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const id = button.dataset.nuWish;
    if (!/^\d+$/.test(id)) return;
    try {
      const ids = read();
      const exists = ids.includes(id);
      localStorage.setItem(key, JSON.stringify(exists ? ids.filter(item => item !== id) : [...ids, id]));
      const card = button.closest('[data-nu-wish-item]');
      render();
      if (card?.hidden) document.querySelector('[data-nu-wishlist] h1')?.focus();
      notify(exists ? 'Usunięto z ulubionych' : 'Dodano do ulubionych', false, button, exists);
    } catch (_) {
      notify('Nie udało się zapisać ulubionych. Sprawdź ustawienia pamięci przeglądarki.', true);
    }
  }, true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-nu-wish-add], [data-nu-wish-cross] .fm80-add, [data-nu-wishlist] .fm80-add');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Dodaję…';
    const error = button.parentElement.querySelector('[role="alert"]');
    if (error) error.hidden = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.nuWishAdd || button.dataset.variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart');
      button.textContent = 'Dodano ✓';
      try { sessionStorage.setItem('fm61-reopen', '1'); } catch (_) {}
      location.reload();
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Dodaj do koszyka';
      if (error) error.hidden = false;
      else button.textContent = 'Spróbuj ponownie';
    }
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) render(); });
  window.addEventListener('pageshow', render);
  document.addEventListener('shopify:section:load', render);
  render();
})();
